import { render } from "./TabNr5.vue?vue&type=template&id=30496799&scoped=true"
import script from "./TabNr5.vue?vue&type=script&lang=js"
export * from "./TabNr5.vue?vue&type=script&lang=js"

import "./TabNr5.vue?vue&type=style&index=0&id=30496799&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30496799"]])

export default __exports__